export default __webpack_public_path__ + "static/media/eym_pt.1595d7a1.svg";